import React, { FC } from 'react'

import { Box } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { EmptyData, ReportWidgetsHeader, StyledWidgetWrapper } from '../../pages/Reports'
import { HorizontalMultiBar } from '../HorizontalMultiBar'

import { PopularityWidgetProps } from './types'

export const PopularityWidget: FC<PopularityWidgetProps> = ({
  title,
  explanation,
  data,
  mainColor,
  strategies,
  currency,
}) => {
  const { t } = useTranslation()
  const emptyData = !strategies ? (
    <EmptyData />
  ) : (
    <EmptyData
      title={t('notEnoughData', 'Not enough data')}
      subtitle={t('pleaseCompleteJournalingSection', 'Please complete "Journaling" section')}
    />
  )

  return (
    <StyledWidgetWrapper>
      <ReportWidgetsHeader text={title} explanation={explanation} />
      <Box mt={4}>
        {!data.length ? (
          emptyData
        ) : (
          <HorizontalMultiBar data={data} mainColor={mainColor} currency={currency} />
        )}
      </Box>
    </StyledWidgetWrapper>
  )
}
